'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceHistoryController = function () {
  function ServiceHistoryController(authService, $scope, loadingService, integrationService, $ngConfirm, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ServiceHistoryController);
    this.authService = authService;
    this.$scope = $scope;
    this.loadingService = loadingService;
    this.integrationService = integrationService;
    this.$ngConfirm = $ngConfirm;
    this.$state = $state;

    this.$scope.$on('vehicleEdit:lookupVehicleSelected', this.showHistory.bind(this));

    this.serviceHistory = null;
    this.recallHistory = null;
  }

  (0, _createClass3.default)(ServiceHistoryController, [{
    key: 'showMazdaAuth',
    value: function showMazdaAuth() {
      var _this = this;

      this.$ngConfirm({
        title: 'Mazda Auth',
        contentUrl: 'templates/vehicle/mazdaAuthConsentTemplate',
        columnClass: 'm',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Yes, take me to Mazda',
            btnClass: 'btn-primary',
            action: function action() {
              if (_this.$state.current.name === 'vehicleAdd') {
                _this.authService.mazdaLogin('vehicleAdd');
              } else {
                _this.authService.mazdaLogin('vehicleEdit', { vehicleId: _this.$state.params.vehicleId });
              }
            }
          },
          no: {
            text: 'No, leave it',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'showHistory',
    value: function showHistory(eventData, data) {
      if (!this.authService.hasActiveMazdaToken() || !data.isMazda || !data.chassisNo) {
        this.serviceHistory = null;
        return;
      }

      this.getMazdaServiceHistory(data.chassisNo);
      this.getMazdaRecallHistory(data.chassisNo);
    }
  }, {
    key: 'getMazdaServiceHistory',
    value: function getMazdaServiceHistory(chassisNo) {
      var _this2 = this;

      this.loadingService.showLoading('serviceHistory', 'Loading Service History ...');

      this.integrationService.getMazdaServiceHistory(this.authService.authData.mazdaToken.access_token, this.authService.authData.mazdaToken.defaultDomain, chassisNo).then(function (response) {
        _this2.serviceHistory = JSON.parse(response.data);
      }).finally(function () {
        _this2.loadingService.hideLoading('serviceHistory');
      });
    }
  }, {
    key: 'getMazdaRecallHistory',
    value: function getMazdaRecallHistory(chassisNo) {
      var _this3 = this;

      this.loadingService.showLoading('serviceHistory', 'Loading Service History ...');

      this.integrationService.getMazdaRecallHistory(this.authService.authData.mazdaToken.access_token, this.authService.authData.mazdaToken.defaultDomain, chassisNo).then(function (response) {
        _this3.recallHistory = (0, _lodash.reverse)(JSON.parse(response.data));
      }).finally(function () {
        _this3.loadingService.hideLoading('serviceHistory');
      });
    }
  }, {
    key: 'getServiceItems',
    value: function getServiceItems(serviceRecord) {
      var serviceItems = (0, _lodash.filter)(serviceRecord.serviceItems, function (si) {
        return si.description !== 'Not Applicable';
      });
      return serviceItems.map(function (si) {
        return si.description;
      });
    }
  }, {
    key: 'getRecallCampaign',
    value: function getRecallCampaign(recallRecord) {
      var campaign = (0, _lodash.find)(recallRecord.campaignVariants, function (cv) {
        return cv.processNumber === recallRecord.campaignNumber;
      });
      return campaign;
    }
  }, {
    key: 'getOpenDefects',
    value: function getOpenDefects() {
      if (this.serviceHistory) {
        return (0, _lodash.filter)(this.serviceHistory.openDefects, function (od) {
          return od.repairStatus === 'OPEN';
        });
      }
    }
  }]);
  return ServiceHistoryController;
}();

exports.default = ServiceHistoryController;


// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleEdit/serviceHistory/serviceHistory.controller.js